import { applyPersistedFrameColors } from './configuratorColors';

/** Shared glazing choice across configurators (localStorage). */
export const GLAZING_STORAGE_KEY = 'config-go-glazing';

const GLAZING_FIELDS = ['glazingType', 'rightGlazingType'];

export function loadPersistedGlazing() {
  try {
    const raw = localStorage.getItem(GLAZING_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const result = {};
    GLAZING_FIELDS.forEach((field) => {
      if (parsed[field]) result[field] = String(parsed[field]);
    });
    return Object.keys(result).length ? result : null;
  } catch {
    return null;
  }
}

export function savePersistedGlazing(updates) {
  if (!updates || typeof updates !== 'object') return;
  const current = loadPersistedGlazing() || {};
  const next = { ...current };
  GLAZING_FIELDS.forEach((field) => {
    if (updates[field]) next[field] = String(updates[field]);
  });
  localStorage.setItem(GLAZING_STORAGE_KEY, JSON.stringify(next));
}

export function applyPersistedGlazing(defaultConfig) {
  const saved = loadPersistedGlazing();
  if (!saved) return { ...defaultConfig };

  const next = { ...defaultConfig };
  GLAZING_FIELDS.forEach((field) => {
    if (saved[field] && field in next) {
      next[field] = saved[field];
    }
  });
  return next;
}

export function trackGlazingChange(field, value) {
  if (!value || !GLAZING_FIELDS.includes(field)) return;
  savePersistedGlazing({ [field]: value });
}

export function applyPersistedConfiguratorPreferences(defaultConfig, colorFields) {
  return applyPersistedGlazing(applyPersistedFrameColors(defaultConfig, colorFields));
}
